module.exports = __webpack_public_path__ + "static/img/r-4-5-icon.deb9e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/r-4-5-icon.png
// module id = hLuG
// module chunks = 0